import { getBoards, updateBoard, newBoard, deleteBoard } from '../api'

const initialState = () => ({
  boards: []
})

const getBoardIndex = (boards, id) => boards.findIndex(b => b.id === id)

export default {
  namespaced: true,
  state: initialState(),

  mutations: {
    setBoards: (state, boards) => (state.boards = boards),
    newBoard: (state, newBoard) => state.boards.push(newBoard),
    updateBoard: (state, newBoard) => state.boards.splice(getBoardIndex(state.boards, newBoard.id), 1, newBoard),
    deleteBoard: (state, id) => state.boards.splice(getBoardIndex(state.boards, id), 1),
    resetState: state => Object.assign(state, initialState())
  },

  actions: {
    getAndSetBoards({ commit }) {
      return getBoards().then(({ data }) => commit('setBoards', data.result))
    },

    updateBoard({ commit }, { name, id }) {
      return updateBoard(id, { name }).then(({ data }) => commit('updateBoard', data.result))
    },

    createBoard({ commit }, payload) {
      return newBoard(payload).then(({ data }) => commit('newBoard', data.result))
    },

    deleteBoard({ commit }, id) {
      return deleteBoard(id).then(() => commit('deleteBoard', id))
    }
  }
}
